import { render } from "./ReportForRepair.vue?vue&type=template&id=2231801f&scoped=true"
import script from "./ReportForRepair.vue?vue&type=script&lang=js"
export * from "./ReportForRepair.vue?vue&type=script&lang=js"

import "./ReportForRepair.vue?vue&type=style&index=0&id=2231801f&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2231801f"]])

export default __exports__